{
  "name": "@zimic/interceptor",
  "description": "Next-gen TypeScript-first HTTP intercepting and mocking",
  "keywords": [
    "zimic",
    "typescript",
    "types",
    "typegen",
    "validation",
    "inference",
    "http",
    "interceptor",
    "mock",
    "api",
    "static"
  ],
  "version": "1.0.1",
  "repository": {
    "type": "git",
    "url": "https://github.com/zimicjs/zimic.git",
    "directory": "packages/zimic-interceptor"
  },
  "author": {
    "name": "Diego Aquino",
    "url": "https://github.com/diego-aquino"
  },
  "funding": {
    "type": "github",
    "url": "https://github.com/sponsors/zimicjs"
  },
  "private": false,
  "publishConfig": {
    "access": "public",
    "provenance": true
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "license": "MIT",
  "files": [
    "package.json",
    "README.md",
    "LICENSE.md",
    "src",
    "!src/**/tests",
    "!src/**/__tests__",
    "!src/**/*.test.ts",
    "dist",
    "index.d.ts",
    "http.d.ts",
    "server.d.ts"
  ],
  "sideEffects": false,
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "index.d.ts",
  "bin": {
    "zimic-interceptor": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "types": "./index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "default": "./dist/index.js"
    },
    "./http": {
      "types": "./http.d.ts",
      "import": "./dist/http.mjs",
      "require": "./dist/http.js",
      "default": "./dist/http.js"
    },
    "./server": {
      "types": "./server.d.ts",
      "import": "./dist/server.mjs",
      "require": "./dist/server.js",
      "default": "./dist/server.js"
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "dev": "tsup --watch",
    "cli": "node --enable-source-maps ./dist/cli.js",
    "build": "tsup",
    "lint": "eslint --cache --no-error-on-unmatched-pattern --no-warn-ignored --fix",
    "lint:turbo": "pnpm lint . --max-warnings 0",
    "style": "prettier --log-level warn --ignore-unknown --no-error-on-unmatched-pattern --cache",
    "style:check": "pnpm style --check",
    "style:format": "pnpm style --write",
    "test": "dotenv -v NODE_ENV=test -v FORCE_COLOR=1 -- vitest",
    "test:turbo": "dotenv -v CI=true -- pnpm run test run --coverage",
    "types:check": "tsc --noEmit",
    "deps:install-playwright": "playwright install chromium",
    "deps:init-msw": "msw init ./public --no-save",
    "deps:prepare": "pnpm deps:install-playwright && pnpm deps:init-msw",
    "postinstall": "node --enable-source-maps -e \"try{require('./dist/scripts/postinstall')}catch(error){console.error(error)}\""
  },
  "dependencies": {
    "@whatwg-node/server": "0.10.12",
    "execa": "9.6.0",
    "isomorphic-ws": "5.0.0",
    "msw": "2.10.4",
    "picocolors": "^1.1.1",
    "ws": "8.18.3",
    "yargs": "18.0.0",
    "zod": "^4.0.17"
  },
  "optionalDependencies": {
    "bufferutil": "4.0.9"
  },
  "devDependencies": {
    "@types/node": "^24.2.1",
    "@types/ws": "^8.18.1",
    "@types/yargs": "^17.0.33",
    "@vitest/browser": "^3.2.4",
    "@vitest/coverage-istanbul": "^3.2.4",
    "@zimic/eslint-config-node": "workspace:*",
    "@zimic/lint-staged-config": "workspace:*",
    "@zimic/tsconfig": "workspace:*",
    "@zimic/utils": "workspace:*",
    "dotenv-cli": "^10.0.0",
    "eslint": "^9.33.0",
    "playwright": "^1.54.2",
    "tsup": "^8.4.0",
    "typescript": "^5.9.2",
    "vitest": "^3.2.4"
  },
  "peerDependencies": {
    "@zimic/http": "^1.0.0 || workspace:*",
    "typescript": ">=5.0.0"
  },
  "peerDependenciesMeta": {
    "typescript": {
      "optional": true
    }
  }
}
